<p-toast></p-toast>

<div
	*ngIf="loading"
	class="flex align-items-center justify-content-center m-0 p-0"
>
	<p-progressSpinner></p-progressSpinner>
</div>

<div class="card-container" *ngIf="!loading && getUser().role_id === 1">
	<div class="card text-center">
		<h2>{{ data?.users }}</h2>
		<p>Usuarios</p>
	</div>

	<div class="card text-center">
		<h2>{{ data?.codes }}</h2>
		<p>Códigos</p>
	</div>

	<div class="card text-center">
		<h2>{{ data?.investments }}</h2>
		<p>Inversiones</p>
	</div>

	<div class="card text-center">
		<h2>{{ data?.transactions }}</h2>
		<p>Transacciones</p>
	</div>
</div>

<div *ngIf="!loading" class="text-center mt-4 infoVersion">
	{{versionApp}}
</div>